// SectionHeading.jsx
import React from 'react';

const SectionHeading = ({ title, subtitle, badgeText }) => {
  return (
    <div
      className="section_title top_content text-center"
      data-aos="fade-up"
      data-aos-duration="1500"
      data-aos-delay="300"
    >
      {badgeText && <span className="title_badge mb-1">{badgeText}</span>}
      <h2>{title}</h2>
      <p className="mb-0">{subtitle}</p>
    </div>
  );
};

export default SectionHeading;
